import { handleActions } from 'redux-actions';
import {
  metaSiteOutsideAppsFetchInitialized,
  metaSiteOutsideAppsFetchSucceeded,
  metaSiteOutsideAppsFetchFailed,
} from '../../../MetaSites';
import { MetaSiteApp } from '../../../interfaces';

const isUnderAddAppsToMetaSiteRoute = new RegExp('/meta-sites/(.*)/o/add-apps');

interface MetaSitesInsideAppsState {
  isLoading: boolean
  failed: boolean
  list: MetaSiteApp[]
  total: number
}

const initialState: MetaSitesInsideAppsState = {
  isLoading: false,
  list: [],
  total: 0,
  failed: false,
};

const reducer = handleActions<MetaSitesInsideAppsState, any>({
  [metaSiteOutsideAppsFetchInitialized.toString()]: state => ({
    ...state,
    list: [],
    failed: false,
    isLoading: true,
  }),
  [metaSiteOutsideAppsFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    list: payload.data,
    total: payload.meta.total,
  }),
  [metaSiteOutsideAppsFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!isUnderAddAppsToMetaSiteRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
